import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';

const StepItem = ({ icon, title, subtitle }) => (
  <ListItem alignItems="flex-start" disableGutters style={{ padding: '8px 0' }}>
    <ListItemIcon style={{ minWidth: 40, marginTop: 4 }}>
      {icon}
    </ListItemIcon>
    <ListItemText
      primary={
        <Typography variant="body1" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
          {title}
        </Typography>
      }
      secondary={
        <Typography variant="caption" style={{ color: '#757575', display: 'block' }}>
          {subtitle}
        </Typography>
      }
    />
  </ListItem>
);

export default StepItem;